import produce from "immer";
import { useState } from "react";

export interface ScreenType {
  size: "standard" | "small";
  width: number;
  height: number;
  orientation: "portrait" | "landscape";
}
const initScreen: ScreenType = {
  size: window.innerWidth <= 1052 ? "small" : "standard",
  orientation:
    window.innerWidth < window.innerHeight ? "portrait" : "landscape",
  width: window.innerWidth,
  height: window.innerHeight,
};

export const useResponsive = () => {
  /* RESPONSIVE */
  const [currentScreen, setSmallScreen] = useState(initScreen);
  /* ********** */

  window.addEventListener("resize", ($ev) => {
    const size =
      ($ev.target as Window).innerWidth <= 1052 ? "small" : "standard";
    const orientation =
      ($ev.target as Window).innerWidth < ($ev.target as Window).innerHeight
        ? "portrait"
        : "landscape";

    setSmallScreen((old) =>
      produce(old, (draft) => {
        draft.size = size;
        draft.orientation = orientation;
      })
    );
  });
  return { currentScreen };
};
